document.addEventListener('DOMContentLoaded', function () {
  // Gallery thumbnails
  var main = document.getElementById('GalleryMain');
  document.querySelectorAll('.gallery-thumbs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (main) main.src = btn.dataset.src;
      document.querySelectorAll('.gallery-thumbs button').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });
});
